"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(script) {
    return ['SCRIPT', 'LOAD', script];
}
exports.transformArguments = transformArguments;
